import { HttpErrorResponse } from '@angular/common/http';
import { OnInit, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BCMCLPUser, CLPUser, TeamCodes, UserResponse } from '../models/clpuser.model';
import { RoleFeaturePermissions } from '../models/role-container.model';
import { GlobalService } from '../services/shared/global.service';
import { LocalService } from '../services/shared/local.service';
import { MenuService } from '../services/shared/menu.service';
import { UtilityService } from '../services/shared/utility.service';
import homeMenu from '../../assets/json/menu.json';
import { gearIcon, questionCircleIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { Title } from '@angular/platform-browser';
import { Search, SearchListResponse } from '../models/search.model';
import { AutoCompleteComponent, DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { SearchContactService } from '../services/shared/search-contact.service';
import { SimpleResponse } from '../models/generic-response.model';
import { AppConfigService } from '../services/shared/app-config.service';
import { ConfigDetails } from '../models/app-config.model';
import { TeamOfficeService } from '../services/team-office.service';
import { CMClubService } from '../services/cm-club.service';
import { CMClub, CMClubResponse, FilterTeam_Load_GeneralResponse, CMSite, CMSiteListResponse } from '../models/cm-club-service.model';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { OnDestroy } from '@angular/core';
import {
    BCMMenu,
    BCMMenuResponse,
    MenuResponse
} from '../models/menu.model';
import { REFMem_GetAllResponse } from '../models/membership.model';
import { SessionService } from '../services/shared/session.service';

declare var $: any;

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit, OnDestroy {
    @ViewChild('autocomplete') autocomplete: AutoCompleteComponent;
    public gear: SVGIcon = gearIcon;
    public question: SVGIcon = questionCircleIcon;
    isExpanded = false;
    private encryptedUser: string = '';
    private copyEncryptedUser: string = '';
    userResponse: UserResponse;
    user: BCMCLPUser;
    roleFeaturePermissions: RoleFeaturePermissions;
    userProfileMenu: { text: string; items: ({ text: string; items?: undefined; } | { text: string; items: any[]; })[]; }[];
    currentMemberNav: string = '';
    homeMenu: any[] = [];
    currentSelectedId: string;
    currentSelectedParentId: string = "-1";
    searchList: Search[] = [];
    inputBoxValue: string = "";
    currentSelectedChildId: string;
    simpleResponse: SimpleResponse;
    showSearch: boolean;
    devSoUrl: string;
    isCmManager: boolean;
    isMembership: boolean;
    teamFilterDD: TeamCodes[];
    filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains',
    };
    routeName: string = '';
    curTeam: TeamCodes = <TeamCodes>{};
    sites: CMSite[];
    curSiteId: number;
    curTeamCode: number = 0
    curSite: CMSite = <CMSite>{}
    clubConfig: CMClub = <CMClub>{};
    cmManagerSUb: Subscription
    routeNameSUb: Subscription
    updateTeamSub: Subscription
    curSiteSub: Subscription
    menuResponse: BCMMenuResponse;
    menus: BCMMenu[];
    mySoUrl: string = ''
    mySoLink: string;
    clpCompanyId: number;
    slurpyUserId: number;
    userRole: number;
    clpUserId: number;
    firstName: string;
    lastName: string;
    isContract: boolean;
    isClientContract: boolean;

    useImage: boolean;
    companyImage: string = "../../assets/img/Engagelogo.png";
    ready: boolean = false;
    engageSite: string;

    previousUrl: string | null = null;
    currentUrl: string | null = null;
    private destroy$ = new Subject<void>();

    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        public _localService: LocalService,
        private _globalService: GlobalService,
        private _utilityService: UtilityService,
        private titleService: Title,
        private _searchContactService: SearchContactService,
        private _menuService: MenuService,
        private _teamOfficeService: TeamOfficeService,
        private clubService: CMClubService,
        private _appconfigService: AppConfigService,
        private sessionService: SessionService,
    ) {

        this.cmManagerSUb = this._localService.isCmManager.pipe(takeUntil(this.destroy$)).subscribe(value => this.isCmManager = value)
        this._localService.isMembership.pipe(takeUntil(this.destroy$)).subscribe(value => this.isMembership = value)
        this.routeNameSUb = this._localService.routeName.pipe(takeUntil(this.destroy$)).subscribe(value => this.routeName = value);
        this._localService.isContract.pipe(takeUntil(this.destroy$)).subscribe(value => this.isContract = value);
        this._localService.isClientContract.pipe(takeUntil(this.destroy$)).subscribe(value => this.isClientContract = value);
    }


    async ngOnInit() {
        this.encryptedUser = await this.sessionService.getSession();
        //const queryParams = this._route.snapshot.queryParams;
        //let currUserToken = localStorage.getItem("token") ? localStorage.getItem("token") : null;
        //if (currUserToken == null) {
        //    this.encryptedUser = queryParams['r'];
        //} else {
        //    this.encryptedUser = currUserToken;
        //}

        if (this.encryptedUser) {

            await this.authenticateR();

            if (this.user) {
                localStorage.setItem("token", this.encryptedUser)
                this.loadData();
            }
            //else {
            //    this.encryptedUser = queryParams['r'];
            //    await this.authenticateR();
            //    if (this.user) {
            //        localStorage.setItem("token", this.encryptedUser)
            //        this.loadData();
            //    }
            //    else {
            //        //this._router.navigate(['/unauthorized']);
            //    }
            //}

        }
        else {
            //this._router.navigate(['/unauthorized']);
        }


        //this._route.queryParams.subscribe(params => {
        //    if (params?.isAI) {
        //        this.isAI = params?.isAI && params?.isAI == 'true' ? true : false
        //    }
        //    else {
        //        this.isAI = localStorage.getItem("isAI") && localStorage.getItem("isAI") == 'true' ? true : false
        //    }
        //    this.encryptedUser = params?.r;
        //    if (!this.encryptedUser?.includes(":")) {
        //        this.encryptedUser = this.encryptedUser + ":" + (this.isAI ? "1" : "0")
        //    }
        //    if (params?.r) {
        //        this.authenticateR().then(() => {
        //            if (this.user) {
        //                this.loadData()
        //            }
        //            else {
        //                this._router.navigate(['/unauthorized']);
        //            }
        //        });
        //    }
        //    else {
        //        this.encryptedUser = localStorage.getItem("token")
        //        this.authenticateR().then(() => {
        //            if (this.user) {
        //                this.loadData()
        //            }
        //            else {
        //                this._router.navigate(['/unauthorized']);
        //            }
        //        });
        //    }
        //})

    }

    loadData() {
        this.updateTeamSub = this._localService.updateTeam.subscribe(value => {
            if (value) {
                this.filterTeamLoadGeneral()
            }
        });

        this._appconfigService.bCMGetConfigKeyValue(this.encryptedUser, "MySO_URL")
            .subscribe(async (result: ConfigDetails) => {
                if (result) {
                    this.mySoUrl = result?.configValue
                }
            });

        this._appconfigService.bCMGetConfigKeyValue(this.encryptedUser, "MySo_Link")
            .pipe(takeUntil(this.destroy$)).subscribe(async (result: ConfigDetails) => {
                if (result) {
                    this.mySoLink = result?.configValue
                }
            });

        this._appconfigService.bCMGetConfigKeyValue(this.encryptedUser, "Engage_Site")
            .pipe(takeUntil(this.destroy$)).subscribe(async (result: ConfigDetails) => {
                if (result) {
                    this.engageSite = result?.configValue;
                }
            });

        this.curSiteSub = this.clubService.curSite.pipe(takeUntil(this.destroy$)).subscribe(async (value: CMSite) => {
            this.curSite = value
            if (this.curSite != null) {
                this.curSiteId = this.curSite?.siteID
                await this.CMClub_Get(this.curTeam?.teamCode)
                this.siteSearch()
            }
            else {
                this.curSite = JSON.parse(localStorage.getItem("curSite") || '{}')
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || '{}')
                this.curSiteId = this.curSite?.siteID
                await this.CMClub_Get(this.curTeam?.teamCode)
                this.siteSearch()
            }
        })

        //this.filterTeamLoadGeneral()
        this.getMenu();
        this.setUserProfileMenu()
        this.homeMenu = homeMenu.homeMenu;
        delete this.homeMenu[0].icon;
        window.localStorage.setItem('sc_lastUser', String(this.clpUserId));
    }

    private async authenticateR() {

        await this._localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                    this.clpCompanyId = this.user?.cLPCompanyID
                    this.slurpyUserId = this.user?.slurpyUserId
                    this.userRole = this.user?.userRole
                    this.clpUserId = this.user?.cLPUserID
                    this.firstName = this.user?.firstName
                    this.lastName = this.user?.lastName
                    this.rEF_Membership_GetAll();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async rEF_Membership_GetAll() {
        await this._localService.rEF_Membership_GetAll(this.encryptedUser, this.user?.cLPCompanyID)
            .then(async (result: REFMem_GetAllResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this._localService.refMem_GetAllResponse = response;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    setUserProfileMenu() {
        this.userProfileMenu = [
            {
                text: this.firstName + " " + this.lastName,
                items: [
                    { text: "Edit Profile" },
                    {
                        text: "Sign out",
                        items: [],
                    },
                ],
            }
        ];
    }

    private async getMenu() {
        await this._menuService.getMenuAI(this.encryptedUser, this.clpUserId, this.clpCompanyId)
            .then(async (result: MenuResponse) => {
                if (result) {
                    this.menuResponse = UtilityService.clone(result);
                    if (this.menuResponse && this.menuResponse.menus) {
                        this.menus = this.menuResponse.menus;

                        this.useImage = this.menuResponse.useImage;
                        this.companyImage = this.useImage ? `../../assets/logos/logo_${this.clpCompanyId}.png` : this.getDefaultLogo();
                        this.ready = true;
                        var removeUrlArr = [];
                        this.menus.forEach(e => {
                            if (e.text == 'Help') {
                                (e as any).i_con = 'help-icon';
                                (e as any).svgIcon = this.question;
                                delete e.text;
                            } else if (e.text == 'Control Panel') {
                                (e as any).i_con = 'setting-icon';
                                (e as any).svgIcon = this.gear;
                                delete e.text;
                            }
                            delete e.url;
                            removeUrlArr.push(e);
                        })
                        this.menus = removeUrlArr;
                        this.menus = this.mapItems(this.menus);
                        this.menus.forEach(item => {
                            if (item.text == 'Companies' || item.text == 'Contacts' || item.text == 'Leads') {
                                if (item.items && item.items.length > 0) {
                                    item.items = item.items.filter((data) => !(data.text === 'Recent' && (!data.items || data.items.length === 0)));
                                }
                            }
                        });
                        this.menus.forEach((z_item, i) => {
                            (z_item as any).uID = i;
                            if (z_item.items.length > 0) {
                                z_item.items.forEach((f_item, j) => {
                                    (f_item as any).uID = j;
                                    if (f_item.items.length > 0) {
                                        f_item.items.forEach((s_item, k) => {
                                            (s_item as any).uID = k;
                                            if (s_item.items.length > 0) {
                                                s_item.items.forEach((t_item, l) => {
                                                    (t_item as any).uID = l;
                                                })
                                            }
                                        })
                                    }
                                });
                            }
                        });
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, null, 'clpUserId ' + this.clpUserId);
                this._utilityService.handleErrorResponse(err);
            });
        //}
        //else {
        //    await this._menuService.getMenu(this.encryptedUser, this.clpUserId, this.clpCompanyId)
        //        .then(async (result: BCMMenuResponse) => {
        //            if (result) {
        //                this.menuResponse = UtilityService.clone(result);
        //                if (this.menuResponse && this.menuResponse.menus) {
        //                    this.menus = this.menuResponse.menus;
        //                    this.useImage = this.menuResponse.useImage;
        //                    this.companyImage = this.useImage ? `../../assets/logos/logo_${this.clpCompanyId}.png` : this.getDefaultLogo();
        //                    this.ready = true;
        //                    var removeUrlArr = [];
        //                    this.menus.forEach(e => {
        //                        if (e.text == 'Help') {
        //                            (e as any).i_con = 'help-icon';
        //                            (e as any).svgIcon = this.question;
        //                            delete e.text;
        //                        } else if (e.text == 'Control Panel') {
        //                            (e as any).i_con = 'setting-icon';
        //                            (e as any).svgIcon = this.gear;
        //                            delete e.text;
        //                        }
        //                        delete e.url;
        //                        removeUrlArr.push(e);
        //                    })
        //                    this.menus = removeUrlArr;
        //                    this.menus = this.mapItems(this.menus);
        //                    this.menus.forEach(item => {
        //                        if (item.text == 'Companies' || item.text == 'Contacts' || item.text == 'Leads') {
        //                            if (item.items && item.items.length > 0) {
        //                                item.items = item.items.filter((data) => !(data.text === 'Recent' && (!data.items || data.items.length === 0)));
        //                            }
        //                        }
        //                    });
        //                    this.menus.forEach((z_item, i) => {
        //                        (z_item as any).uID = i;
        //                        if (z_item.items.length > 0) {
        //                            z_item.items.forEach((f_item, j) => {
        //                                (f_item as any).uID = j;
        //                                if (f_item.items.length > 0) {
        //                                    f_item.items.forEach((s_item, k) => {
        //                                        (s_item as any).uID = k;
        //                                        if (s_item.items.length > 0) {
        //                                            s_item.items.forEach((t_item, l) => {
        //                                                (t_item as any).uID = l;
        //                                            })
        //                                        }
        //                                    })
        //                                }
        //                            });
        //                        }
        //                    });
        //                }
        //            }
        //        })
        //        .catch((err: HttpErrorResponse) => {
        //            this._globalService.error("buzz-index.getLeadHistory", err.message, null, 'clpUserId ' + this.clpUserId);
        //            this._utilityService.handleErrorResponse(err);
        //        });
        //}

    }

    getDefaultLogo() {
        switch (this.user?.userRole) {
            case 3: {//nimbus
                return '../../assets/logos/nimbuslogo.png';
            }
            case 2: {//Cirrus
                return '../../assets/logos/cirruslogo.png';
            }
            case 0: {//StratusExpress
                return '../../assets/logos/stratusxlogo.png';
            }
            default: {
                return '../../assets/logos/stratuslogo.png';
            }
        }
    }

    private mapItems(menu: any, path?: string): any[] {
        return menu.map((item) => {
            const result: any = {
                svgIcon: item.svgIcon,
                icon: item.icon,
                text: item.text,
                path: item.url,
                i_con: item?.i_con,
            };
            if (item.items) {
                result.items = this.mapItems(item.items, item.url);
            }
            return result;
        });
    }

    public onSelectHomeDesktop(itemObj): void {
        let e = itemObj?.originalEvent
        let item = itemObj?.item
        var arr = this.encryptedUser.split(":");
        if (item?.text && item?.text != '') {
            switch (item?.text) {
                case "Documents":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/my-documents");
                        w.document.title = 'Documents';
                        /*this.titleService.setTitle('Documents');*/
                    }
                    else {
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/my-documents";
                        window.location.href = url
                        this.titleService.setTitle('Documents');
                        localStorage.setItem("title", 'Documents');
                    }
                    break;
                case "Profile":
                    if (e?.ctrlKey || e?.metaKey) {
                        //var w = window.open("edit-profile/" + this.clpUserId);
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/edit-profile/" + this.user?.cLPUserID);
                        w.document.title = 'Edit Profile';
                    }
                    else {
                        //this._router.navigate(['/edit-profile', this.clpUserId]);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/edit-profile/" + this.user?.cLPUserID;
                        window.location.href = url
                        this.titleService.setTitle('Edit Profile');
                        localStorage.setItem("title", 'Edit Profile');
                    }

                    break;
                case "Schedule":
                    if (e?.ctrlKey || e?.metaKey) {
                        //var w = window.open("calender/scheduler");
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/calender/scheduler");
                        w.document.title = 'Calender Scheduler';
                    }
                    else {
                        //this._router.navigate(['/calender/scheduler']);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/calender/scheduler";
                        window.location.href = url;
                        this.titleService.setTitle('Calender Scheduler');
                        localStorage.setItem("title", 'Calender Scheduler');
                    }
                    break;
                case "Call List":
                    var routeUrl: string = '';
                    routeUrl = this.clpCompanyId === 1226 ? 'call-ih' : 'call';
                    if (e?.ctrlKey || e?.metaKey) {
                        //var w = window.open(routeUrl);
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/" + routeUrl);
                        w.document.title = 'Call';
                    }
                    else {
                        //this._router.navigateByUrl(routeUrl);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/" + routeUrl;
                        window.location.href = url;
                        this.titleService.setTitle('Call');
                        localStorage.setItem("title", 'Call');

                    }
                    break;
                case "View Goals":
                    if (e?.ctrlKey || e?.metaKey) {

                        //var w = window.open("/goal");
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/goal");
                        w.document.title = 'View Goal';
                    }
                    else {
                        //this._router.navigate(['/goal']);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/goal";
                        window.location.href = url;
                        this.titleService.setTitle('View Goal');
                        localStorage.setItem("title", 'View Goal');

                    }
                    break;
                case "Tasks":
                    if (e?.ctrlKey || e?.metaKey) {

                        //var w = window.open("/goal");
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/task");
                        w.document.title = 'View Task';
                    }
                    else {
                        //this._router.navigate(['/goal']);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/task";
                        window.location.href = url;
                        this.titleService.setTitle('View Task');
                        localStorage.setItem("title", 'View Task');

                    }
                    break;
                case "Home":
                    if (e?.ctrlKey || e?.metaKey) {

                        //var w = window.open("/goal");
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/home");
                        w.document.title = 'Engage';
                    }
                    else {
                        //this._router.navigate(['/goal']);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/home";
                        window.location.href = url;
                        this.titleService.setTitle('Engage');
                        localStorage.setItem("title", 'Engage');

                    }
                    break;
                case "Mailings":
                    if (e?.ctrlKey || e?.metaKey) {

                        //var w = window.open("/goal");
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/marketing/view?type=2");
                        w.document.title = 'Mailing';
                    }
                    else {
                        //this._router.navigate(['/goal']);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/marketing/view?type=2";
                        window.location.href = url;
                        this.titleService.setTitle('Mailing');
                        localStorage.setItem("title", 'Mailing');

                    }
                    break;
                case "Goals Setup":

                    if (e?.ctrlKey || e?.metaKey) {

                        //var w = window.open("/goal");
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/goal/setup");
                        w.document.title = 'Setup Goal';
                    }
                    else {
                        //this._router.navigate(['/goal']);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/goal/setup";
                        window.location.href = url;
                        this.titleService.setTitle('Setup Goal');
                        localStorage.setItem("title", 'Setup Goal');

                    }

                    break;
                case "New Appointment":
                    if (this.clpCompanyId == 1226 || this.clpCompanyId == 1321) {
                        if (e?.ctrlKey || e?.metaKey) {

                            //var w = window.open("/goal");
                            var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/appointment-ih");
                            w.document.title = 'New Appointment';
                        }
                        else {
                            //this._router.navigate(['/goal']);
                            let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/appointment-ih";
                            window.location.href = url;
                            this.titleService.setTitle('New Appointment');
                            localStorage.setItem("title", 'New Appointment');

                        }
                    }
                    else {
                        if (e?.ctrlKey || e?.metaKey) {

                            //var w = window.open("/goal");
                            var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/appointment");
                            w.document.title = 'New Appointment';
                        }
                        else {
                            //this._router.navigate(['/goal']);
                            let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/appointment";
                            window.location.href = url;
                            this.titleService.setTitle('New Appointment');
                            localStorage.setItem("title", 'New Appointment');

                        }
                    }
                    break;
                case "Appointment List":
                    if (e?.ctrlKey || e?.metaKey) {

                        //var w = window.open("/goal");
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/appointment-list");
                        w.document.title = 'Appointment List';
                    }
                    else {
                        //this._router.navigate(['/goal']);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/appointment-list";
                        window.location.href = url;
                        this.titleService.setTitle('Appointment List');
                        localStorage.setItem("title", 'Appointment List');

                    }
                    break;
                case "Bulk Appointment Wizard":
                    if (e?.ctrlKey || e?.metaKey) {

                        //var w = window.open("/goal");
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/bulk-appointment");
                        w.document.title = 'Bulk Appointment Wizard';
                    }
                    else {
                        //this._router.navigate(['/goal']);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/bulk-appointment";
                        window.location.href = url;
                        this.titleService.setTitle('Bulk Appointment Wizard');
                        localStorage.setItem("title", 'Bulk Appointment Wizard');

                    }
                    break;
                case "New Recurring Appointment":
                    if (e?.ctrlKey || e?.metaKey) {

                        //var w = window.open("/goal");
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/calendar/recurringappt");
                        w.document.title = 'New Recurring Appointment';
                    }
                    else {
                        //this._router.navigate(['/goal']);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/calendar/recurringappt"
                        window.location.href = url;
                        this.titleService.setTitle('New Recurring Appointment');
                        localStorage.setItem("title", 'New Recurring Appointment');

                    }
                    break;
                case "Dynamic Schedulers":
                    if (e?.ctrlKey || e?.metaKey) {

                        //var w = window.open("/goal");
                        var w = window.open(this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/calendar/pcallist");
                        w.document.title = 'Dynamic Schedulers';
                    }
                    else {
                        //this._router.navigate(['/goal']);
                        let url = this.engageSite + "/bcm-redirect?r=" + arr[0] + "&url=/calendar/pcallist";
                        window.location.href = url;
                        this.titleService.setTitle('Dynamic Schedulers');
                        localStorage.setItem("title", 'Dynamic Schedulers');

                    }
                    break;
                case "Calendar":
                case "Goals":
                    {
                        break;
                    }
                default:
                    //$('#underConstruction').modal('show');
                    break;
            }
            this.currentSelectedId = "-1";
            this.currentSelectedParentId = "-1";
        }
    }

    goToLink(value: string, str: string = "") {
        var arr = this.encryptedUser.split(':');
        if (value) {
            var id = this.searchList.filter(item => item.searchText == value)[0]?.searchValue;
            if (id?.includes("ct")) {
                var contactId = id?.split("ct")[1];
                let url = this.engageSite + '/bcm-redirect?r=' + arr[0] + '&url=/contact/' + contactId;
                window.location.href = url
                this.titleService.setTitle('View Contact');
                localStorage.setItem("title", 'View Contact');
                //this._router.navigate(['/contact', this.clpUserId, contactId]);
                //this.autocomplete.reset();
            }
            else if (id?.includes("cp")) {
                var companyId = id?.split("cp")[1];
                let url = this.engageSite + '/bcm-redirect?r=' + arr[0] + '&url=/company-create?cid=' + companyId;
                window.location.href = url
                //this._router.navigateByUrl(`company-create?cid=${companyId}`);
                this.autocomplete.reset();
            }
            else {
                this.autocomplete.reset();
                let url = this.engageSite + '/bcm-redirect?r=' + arr[0] + '&url=/home/search?txt=' + this.inputBoxValue;
                window.location.href = url
                //this._router.navigateByUrl(`/home/search?txt=${this.inputBoxValue}`);
            }
        }
        else {
            this.autocomplete.reset();
            let url = this.mySoUrl + '?r=' + arr[0] + '&ReturnUrl=' + this.mySoLink + 'home/search.aspx?txt=' + this.inputBoxValue;
            window.location.href = url
            //this._router.navigateByUrl(`/home/search?txt=${this.inputBoxValue}`);

        }
    }

    getSearchData(txt: string, value: string = "") {
        let Search: Search = <Search>{};

        Search.searchText = txt;
        this.inputBoxValue = txt;
        Search.searchValue = "";
        this.getContactSearch(Search);
    }

    getContactSearch(searchData: Search) {
        this._searchContactService.getContactSearchData(this.encryptedUser, this.clpUserId, searchData)
            .then(async (result: SearchListResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.searchList = response.searchList;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, null, "clpUserId " + this.clpUserId + "," + "searchData " + searchData);
                this._utilityService.handleErrorResponse(err);
            });
    }

    public onSelectParentDesktop(itemObj) {
        let e = itemObj?.originalEvent
        let item = itemObj?.item
        if (item.items.length == 0) {
            if (item.path != "") {
                this.currentSelectedId = "-1";
                this.currentSelectedParentId = "-1";
                this.currentSelectedChildId = "-1";
                if (item.text != "") {
                    switch (item.text) {
                        case "View": {
                            if (item.path?.includes("lead-detail")) {
                                let leadId = Number(item.path.split("lead-detail/")[1]);
                                if (e?.ctrlKey || e?.metaKey) {
                                    window.open(item?.path);

                                }
                                else {
                                    window.location.href = item?.path;
                                }
                            }
                            else if (item.path?.includes("/company-create")) {
                                let cid = Number(item.path.split("cid=")[1]);
                                if (e?.ctrlKey || e?.metaKey) {
                                    window.open(item?.path);
                                }
                                else {

                                    window.location.href = item?.path;
                                }
                                break;
                            }
                            else {
                                let contactId = Number(this.getContactIdFromPath(item.path));
                                if (e?.ctrlKey || e?.metaKey) {

                                    window.open(item?.path);
                                }
                                else {
                                    window.location.href = item?.path;

                                }
                            }
                            break;
                        }
                        case "Create Referral": {
                            let rId = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path.substring(lastIndex + 1);
                                rId = Number(part2);
                            }
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path;

                            }
                            break;
                        }
                        case "View History": {
                            let contactId = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path?.substring(lastIndex + 1);
                                contactId = Number(part2);
                            }
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path;


                            }
                            break;
                        }
                        case "View Documents": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path

                            }
                            break;
                        }
                        case "View Appointments": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path

                            }

                            break;
                        }
                        case "New Lead": {
                            let cid = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path.substring(lastIndex + 1);
                                cid = Number(part2);
                            }
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path;

                            }
                            break;
                        }
                        case "New Contact": {
                            let cid = Number(item.path.split("cid=")[1]);
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path;

                            }
                            break;
                        }
                        case "View Tasks": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path)
                            }
                            else {
                                window.location.href = item?.path

                            }
                            break;
                        }
                        case "Edit": {
                            if (item.path?.includes("lead-detail")) {
                                let value = item.path?.split("lead-detail/")[1];
                                let leadId = Number(value?.split("&")[0]);
                                if (e?.ctrlKey || e?.metaKey) {

                                    window.open(item?.path);
                                }
                                else {
                                    window.location.href = item?.path

                                }
                            }
                            else {
                                let contactId = Number(this.getContactIdFromPath(item.path));
                                if (e?.ctrlKey || e?.metaKey) {

                                    window.open(item?.path);
                                }
                                else {
                                    window.location.href = item?.path

                                }
                            }
                            break;
                        }
                        case "New Task": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path

                            }
                            break;
                        }
                        case "Membership": {
                            //window.open(item.path);
                            window.open("/mem-membership-list", "_blank");
                            break;
                        }
                        case "Club Manager": {
                            //window.open(item.path);
                            window.open("/cm-dashboard","_blank");
                            break;
                        }
                        default: {
                            if (e?.ctrlKey || e?.metaKey) {

                                if (item.path?.includes("/help/")) {
                                    window.open(item.path);
                                }
                                else {
                                    window.open(item.path)
                                }
                            }
                            else {
                                if (item.path?.includes("/help/")) {
                                    window.open(item.path);
                                }
                                else {
                                    window.location.href = item.path;
                                }

                            }
                            this.titleService.setTitle(item.text);
                            localStorage.setItem("title", item.text);
                            break;
                        }

                    }

                }
                this.toggleNavBar();
            }
            else {
                this.currentSelectedId = "-1";
                this.currentSelectedParentId = "-1";
                this.currentSelectedChildId = "-1";
                this.toggleNavBar();
            }
        } else {
            if (item.text == 'Contacts') {
                this._router.navigate(['/contacts']);
            }
            if (item.icon) {
                var split_string = item.icon?.split("/");
                var newitem = split_string[split_string.length - 1];
                newitem = newitem.replace(/ /g, "").toLowerCase();
            } else if (item.text) {
                var newitem = item.text.replace(/ /g, "").toLowerCase();
            }

        }

    }

    toggleNavBar() {
        let element: HTMLElement = document.getElementsByClassName('navbar-toggler')[0] as HTMLElement;
        if (element.getAttribute('aria-expanded') == 'true') {
            element.click();
        }
    }

    getContactIdFromPath(inputString: string) {
        const lastIndex = inputString.lastIndexOf('/');
        if (lastIndex !== -1 && lastIndex + 1 < inputString.length) {
            const part2 = inputString.substring(lastIndex + 1);
            if (part2.includes('&')) {
                let value = part2?.split("&")[0];
                return value
            }
            return part2
        }
        return 0
    }


    onSelectUserMenu(item) {
        let e = item?.originalEvent
        var arr = this.encryptedUser.split(':')
        switch (item?.item?.text) {
            case "Edit Profile":
                if (e?.ctrlKey || e?.metaKey) {

                    var w = window.open(this.engageSite + "/edit-profile/" + this.user?.cLPUserID);
                    w.document.title = 'Documents';
                    /*this.titleService.setTitle('Documents');*/
                }
                else {
                    let url = this.engageSite + "/edit-profile/" + this.user?.cLPUserID;
                    window.location.href = url

                }


                break;
            case "Sign out":
                this.logout();
                break;
        }
    }

    public onSelectParent(item, type: string, e: MouseEvent) {
        type = '' + type;
        if (item.items.length == 0) {
            if (item.path != "") {
                this.currentSelectedId = "-1";
                this.currentSelectedParentId = "-1";
                this.currentSelectedChildId = "-1";
                if (item.text != "") {
                    switch (item.text) {
                        case "View": {
                            if (item.path?.includes("lead-detail")) {
                                let leadId = Number(item.path.split("lead-detail/")[1]);
                                if (e?.ctrlKey || e?.metaKey) {

                                    window.open(item?.path);
                                }
                                else {
                                    window.location.href = item?.path;

                                }
                            }
                            else if (item.path?.includes("/company-create")) {
                                let cid = Number(item.path.split("cid=")[1]);
                                if (e?.ctrlKey || e?.metaKey) {

                                    window.open(item?.path);
                                }
                                else {
                                    window.location.href = item?.path;

                                }
                                break;
                            }
                            else {
                                let contactId = Number(this.getContactIdFromPath(item.path));
                                if (e?.ctrlKey || e?.metaKey) {

                                    window.open(item?.path);
                                }
                                else {
                                    window.location.href = item?.path

                                }
                            }
                            break;
                        }
                        case "Create Referral": {
                            let rId = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path.substring(lastIndex + 1);
                                rId = Number(part2);
                            }
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path;

                            }
                            break;
                        }
                        case "View History": {
                            let contactId = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path?.substring(lastIndex + 1);
                                contactId = Number(part2);
                            }
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path;

                            }
                            break;
                        }
                        case "View Documents": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path;

                            }
                            break;
                        }
                        case "New Lead": {
                            let cid = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path.substring(lastIndex + 1);
                                cid = Number(part2);
                            }
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path;

                            }
                            break;
                        }
                        case "New Contact": {
                            let cid = Number(item.path.split("cid=")[1]);
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {
                                window.location.href = item?.path;

                            }
                            break;
                        }
                        case "View Tasks": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path);
                            }
                            else {

                                window.location.href = item?.path;

                            }
                            break;
                        }
                        case "Edit": {
                            if (item.path?.includes("lead-detail")) {
                                let value = item.path?.split("lead-detail/")[1];
                                let leadId = Number(value?.split("&")[0]);
                                if (e?.ctrlKey || e?.metaKey) {

                                    window.open("lead-detail/" + leadId);
                                    window.open(item?.path);
                                }
                                else {
                                    this._router.navigate(['/lead-detail/', leadId]);
                                    window.location.href = item?.path;

                                }
                            }
                            else {
                                let contactId = Number(this.getContactIdFromPath(item.path));
                                if (e?.ctrlKey || e?.metaKey) {

                                    window.open("contact/" + contactId);
                                    window.open(item?.path);
                                }
                                else {
                                    this._router.navigate(['/contact/', contactId]);
                                    window.location.href = item?.path;

                                }
                            }
                            break;
                        }
                        case "New Task": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            if (e?.ctrlKey || e?.metaKey) {

                                window.open(item?.path + "?isNew=true");
                            }
                            else {
                                window.location.href = item?.path + "?isNew=true";

                            }
                            break;
                        }
                        case "Membership": {
                            window.open(item.path);
                            break;
                        }
                        case "Club Manager": {
                            window.open(item.path);
                            break;
                        }
                        default: {
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open(item?.path);

                            }
                            else {

                                window.location.href = item?.path;
                            }
                            this.titleService.setTitle(item.text);
                            localStorage.setItem("title", item.text);
                            break;
                        }

                    }

                }
                this.toggleNavBar();
            }
            else {
                this.currentSelectedId = "-1";
                this.currentSelectedParentId = "-1";
                this.currentSelectedChildId = "-1";
                this.toggleNavBar();
            }
        } else {
            if (item.i_con) {
                var split_string = item.i_con?.split("/");
                var newitem = split_string[split_string.length - 1];
                newitem = newitem.replace(/ /g, "").toLowerCase();
            } else if (item.text) {
                var newitem = item.text.replace(/ /g, "").toLowerCase();
            }

            switch (type) {
                case "0": {
                    //for hiding toggler on click of icon
                    if (item.i_con) {
                        this.toggleNavBar();
                        if (this.showSearch)
                            this.showSearch = !this.showSearch;
                    }


                    if (this.currentSelectedParentId == newitem)
                        this.currentSelectedParentId = "-1";
                    else
                        this.currentSelectedParentId = newitem;
                    break;
                }
                case "1": {
                    if (this.currentSelectedId == newitem)
                        this.currentSelectedId = "-1";
                    else
                        this.currentSelectedId = newitem;
                    break;
                }
                case "2": {
                    if (this.currentSelectedChildId == newitem)
                        this.currentSelectedChildId = "-1";
                    else
                        this.currentSelectedChildId = newitem;
                    break;
                    break;
                }
                default: {
                    break;
                }
            }
        }

    }

    onMouseOver(item, type: string) {
        this.menus?.forEach(z_item => {
            if (type == '0') {
                if (((item?.text && z_item.text == item?.text) || (item.icon && z_item.icon == item.icon)) && (z_item as any).uID == item?.uID)
                    (z_item as any).dClass = 'active';
                else
                    (z_item as any).dClass = '';
            }
            if (z_item.items.length > 0) {
                z_item.items.forEach(f_item => {
                    if (type == '1') {
                        if (((item?.text && f_item?.text == item?.text) || (item.icon && f_item.icon == item.icon)) && (f_item as any).uID == item?.uID)
                            (f_item as any).dClass = 'active';
                        else
                            (f_item as any).dClass = '';
                    }
                    if (f_item.items.length > 0) {
                        f_item.items.forEach(s_item => {
                            if (type == '2') {
                                if (((item?.text && s_item?.text == item?.text) || (item.icon && s_item.icon == item.icon)) && (s_item as any).uID == item?.uID)
                                    (s_item as any).dClass = 'active';
                                else
                                    (s_item as any).dClass = '';
                            }
                            if (s_item.items.length > 0) {
                                s_item.items.forEach(t_item => {
                                    if (type == '3') {
                                        if (((item?.text && t_item?.text == item?.text) || (item.icon && t_item.icon == item.icon)) && (t_item as any).uID == item?.uID)
                                            (t_item as any).dClass = 'active';
                                        else
                                            (t_item as any).dClass = '';
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

    }

    logout() {
        this._localService.userTokenSignout(this.encryptedUser)
            .then(async (result: SimpleResponse) => {
                if (result && result.messageBool) {
                    localStorage.removeItem("token");
                    localStorage.clear();
                    this.sessionService.logout();
                    this.titleService.setTitle('Engage');
                    window.location.href = this.engageSite;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("localservice.logout", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    public onSelectHome(item, e: MouseEvent): void {
        if (item.text && item.text != '') {
            switch (item.text) {
                case "Documents":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'Documents';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('Documents');
                        localStorage.setItem("title", 'Documents');

                    }

                    break;
                case "Profile":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'Edit Profile';
                    }
                    else {
                        let url = this.mySoUrl + '/security/authenticate.aspx?r=' + this.encryptedUser + '&ReturnUrl=' + this.mySoLink + 'profile/default.aspx'
                        window.location.href = url
                        this.titleService.setTitle('Edit Profile');
                        localStorage.setItem("title", 'Edit Profile');

                    }

                    break;
                case "Schedule":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'Edit Profile';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('Calender Scheduler');
                        localStorage.setItem("title", 'Calender Scheduler');

                    }
                    break;
                case "Call List":
                    var routeUrl: string = '';
                    routeUrl = this.clpCompanyId === 1226 ? 'call-ih' : 'call';
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'Call';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('Call');
                        localStorage.setItem("title", 'Call');

                    }
                    break;
                case "View Goals":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'View Goal';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('View Goal');
                        localStorage.setItem("title", 'View Goal');

                    }
                    break;
                case "Tasks":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'View Task';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('View Task');
                        localStorage.setItem("title", 'View Task');

                    }
                    break;
                case "Home":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'Home';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('Home');
                        localStorage.setItem("title", 'Home');

                    }
                    break;
                case "Mailings":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'Mailing';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('Mailing');
                        localStorage.setItem("title", 'Mailing');

                    }
                    break;
                case "Goals Setup":

                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'Setup Goal';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('Setup Goal');
                        localStorage.setItem("title", 'Setup Goal');

                    }

                    break;
                case "New Appointment":
                    if (this.clpCompanyId == 1226 || this.clpCompanyId == 1321) {
                        if (e?.ctrlKey || e?.metaKey) {

                            var w = window.open(item?.path);
                            w.document.title = 'New Appointment';
                        }
                        else {
                            window.location.href = item?.path;
                            this.titleService.setTitle('New Appointment');
                            localStorage.setItem("title", 'New Appointment');

                        }
                    }
                    else {
                        if (e?.ctrlKey || e?.metaKey) {

                            var w = window.open(item?.path);
                            w.document.title = 'New Appointment';
                        }
                        else {
                            window.location.href = item?.path;
                            this.titleService.setTitle('New Appointment');
                            localStorage.setItem("title", 'New Appointment');

                        }
                    }
                    break;
                case "Appointment List":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'Appointment List';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('Appointment List');
                        localStorage.setItem("title", 'Appointment List');

                    }
                    break;
                case "Bulk Appointment Wizard":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'Bulk Appointment Wizard';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('Bulk Appointment Wizard');
                        localStorage.setItem("title", 'Bulk Appointment Wizard');

                    }
                    break;
                case "New Recurring Appointment":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'New Recurring Appointment';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('New Recurring Appointment');
                        localStorage.setItem("title", 'New Recurring Appointment');

                    }
                    break;
                case "Dynamic Schedulers":
                    if (e?.ctrlKey || e?.metaKey) {

                        var w = window.open(item?.path);
                        w.document.title = 'Dynamic Schedulers';
                    }
                    else {
                        window.location.href = item?.path;
                        this.titleService.setTitle('Dynamic Schedulers');
                        localStorage.setItem("title", 'Dynamic Schedulers');

                    }
                    break;
                default:
                    break;
            }
            this.currentSelectedId = "-1";
            this.currentSelectedParentId = "-1";
        }
    }

    toggleSearch() {
        this.showSearch = !this.showSearch;
        if (this.showSearch)
            this.toggleNavBar();
    }

    resetMenuState() {
        this.currentSelectedParentId = "-1";
        this.currentSelectedId = "-1";
        this.currentSelectedChildId = "-1";
    }

    getUniqueId(name: string) {
        if (name?.includes('.svg')) {
            var split_string = name?.split("/");
            var newitem = split_string[split_string.length - 1];
            newitem = newitem.replace(/ /g, "").toLowerCase();
            return newitem;
        }
        else
            return name?.replace(/ /g, "").toLowerCase();
    }

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
    }

    isShowIcon(value: string) {
        if (value?.includes("cpgear"))
            return true;
        else
            return false;
    }

    goToCM() {
        this._router.navigate(['/cm-general'])
    }

    goToMembership() {
        switch (this.routeName) {
            case 'mem-membership':
                this._router.navigate(['/mem-membership-list'])
                return true;
            case 'mem-pause':
                this._router.navigate(['/mem-pause-list'])
                return true;
            case 'mem-insurance':
                this._router.navigate(['/mem-insurance-list'])
                return true;
            case 'mem-policy-violation':
                this._router.navigate(['/mem-policy-violation-list'])
                return true;
            case 'mem-case':
                this._router.navigate(['/mem-case-list'])
                return true;
            case 'mem-subscription':
                this._router.navigate(['/mem-subscription-list'])
                return true;
        }
    }

    async filterTeamLoadGeneral() {
        await this.clubService.filterTeamLoadGeneral(this.encryptedUser, this.clpCompanyId, 0, false)
            .then(async (result: FilterTeam_Load_GeneralResponse) => {
                if (result) {
                    this.teamFilterDD = UtilityService.clone(result?.filterMappedTeams);
                    this.teamFilterDD.unshift({
                        teamCode: 0,
                        cLPCompanyID: this.clpCompanyId,
                        display: "Select",
                        sOrder: 0,
                        companyName: ""
                    });
                    if (this.userRole >= 3 || this.slurpyUserId > 0) {
                        this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                        //this.curTeamCode = 0
                        this.curTeamCode = this.curTeam?.teamCode > 0 ? this.curTeam?.teamCode : 0
                    }
                    else {
                        this.curTeam = result?.team
                        localStorage.setItem("curTeam", JSON.stringify(this.curTeam))
                        this._teamOfficeService.setCurTeam(this.curTeam)
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.sites = response?.sites
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    onChangeSite(siteId) {
        this.curSiteId = siteId
        this.curSite = this.sites.filter((item) => item?.siteID == siteId)[0]
        localStorage.setItem("curSite", JSON.stringify(this.curSite))
        this.clubService.setCurSite(this.curSite)

    }

    async onChangeTeam(teamCode) {
        this.curTeam = this.teamFilterDD?.filter((item) => item?.teamCode == teamCode)[0]
        this._teamOfficeService.setCurTeam(this.curTeam)
        localStorage.setItem("curTeam", JSON.stringify(this.curTeam))
        await this.CMClub_Get(this.curTeam?.teamCode)
        this.siteSearch()
    }

    newClub() {
        this.curTeamCode = 0
        localStorage.removeItem("curTeam")
        localStorage.removeItem("curSite")
        this._teamOfficeService.setCurTeam(null)
        this.clubService.setCurClubId(-1)
    }

    async CMClub_Get(teamCode) {
        if (!teamCode || teamCode == 0) {
            return
        }
        await this.clubService.CMClub_Get(this.encryptedUser, this.clpCompanyId, teamCode).
            then(async (result: CMClubResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clubConfig = response?.clubConfig
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("site-fields.clubConfigGet", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }




    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.cmManagerSUb) {
            this.cmManagerSUb.unsubscribe()
        }
        if (this.routeNameSUb) {
            this.routeNameSUb.unsubscribe()
        }
        if (this.updateTeamSub) {
            this.updateTeamSub.unsubscribe()
        }
        if (this.curSiteSub) {
            this.curSiteSub.unsubscribe()
        }
    }

    isShowTeamDDOnRoute() {
        switch (this.routeName) {
            case 'sm-dashboard':
                return true;
            case 'sm-general':
                return true;
            case 'sm-triggers':
                return true;
            case 'sm-links':
                return true;
            case 'sm-marketing':
                return true;
            case 'sm-employees':
                return true;
            case 'sm-engage-dash':
                return true;
            case 'sm-products':
                return true;
            case 'sm-contract-settings':
                return true;
            case 'sm-contracts':
                return true;

            //case 'mem-membership-list':
            //    return true;
            //case 'mem-pause-list':
            //    return true;
            //case 'mem-insurance-list':
            //    return true;
            //case 'mem-policy-violation-list':
            //    return true;
            //case 'mem-case-list':
            //    return true;
            //case 'mem-subscription-list':
            //    return true;
        }
    }

    isShowBackToMem() {
        switch (this.routeName) {
            case 'mem-membership':
                this.currentMemberNav = 'Memberships'
                return true;
            case 'mem-pause':
                this.currentMemberNav = 'Pauses'
                return true;
            case 'mem-insurance':
                this.currentMemberNav = 'Insurance'
                return true;
            case 'mem-policy-violation':
                this.currentMemberNav = 'Policy Voilactions'
                return true;
            case 'mem-case':
                this.currentMemberNav = 'Cases'
                return true;
            case 'mem-subscription':
                this.currentMemberNav = 'Subscriptions'
                return true;
        }
    }
}
